export const languageElements = {
  items: {
    "header-title-greeting": {
      hu: "ÜGYFÉLKAPU",
      de: "CUSTOMER PORTAL",
      en: "CUSTOMER PORTAL",
    },

    "header-title-dismissRegistration": {
      hu: "LEIRATKOZÁS",
      de: "ABMELDUNG",
      en: "UNSUBSCRIBE",
    },

    "header-title-firstLogin": {
      hu: "Első belépés",
      de: "Erste Anmeldung",
      en: "First login",
    },

    "header-title-login": {
      hu: "ÜGYFÉLKAPU - Belépés",
      de: "CUSTOMER PORTAL - Login",
      en: "CUSTOMER PORTAL - Login",
    },

    "header-title-invoices": {
      hu: "Számláim",
      de: "Abrechnungen",
      en: "Invoices",
    },

    "header-title-warehouse": {
      hu: "Raktár",
      de: "Lager",
      en: "Warehouse",
    },

    "header-title-warehouse-stocks": {
      hu: "Készlet információ",
      de: "Warenbestände",
      en: "Stocks of goods",
    },

    "header-title-warehouse-journal": {
      hu: "Mozgási napló",
      de: "Lager Journal",
      en: "Warehouse - Journal",
    },

    "header-title-stocks": {
      hu: "Készlet információ",
      de: "Warenbestände",
      en: "Stocks of goods",
    },

    "header-title-tracking": {
      hu: "Fuvarjaim",
      de: "Frächte",
      en: "Freight",
    },

    "header-title-settings": {
      hu: "Beállítások",
      de: "Einstellungen",
      en: "Settings",
    },

    "header-title-contact": {
      hu: "Kapcsolat",
      de: "Kontakt",
      en: "Contact",
    },
  },
};
